<app-base-modal [id]="modalId" [title]="modalData.modalTitle | translate" [size]="'large'">
  <app-base-modal-body>
    <app-video-player
      [videoYoutubeId]="modalData.videoYoutubeId"
      [thumbnailSrc]="modalData.thumbnailSrc"
      #videoPlayer
    ></app-video-player>
  </app-base-modal-body>
</app-base-modal>
